import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import { ArrowLeftFilled } from '@fluentui/react-icons';
import { useNavigate } from 'react-router-dom';
import usePageHeaderStyles from './usePageHeaderStyles';
import { truncateText } from '@ui/constants/truncateText';
const PageHeader = ({ title, icons, filters, goBack, breadcrumbs }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { pageHeaderStyles, filterSectionStyles, titleContainerStyles, iconContainerStyles } = usePageHeaderStyles();
    const handleGoBack = () => {
        if (goBack && typeof goBack === 'boolean') {
            if (breadcrumbs === 'Assets') {
                navigate(`/detail-asset`);
            }
            else {
                navigate(-1);
            }
        }
        else {
            goBack && goBack();
        }
    };
    return (_jsxs(Box, { className: 'page__header', sx: pageHeaderStyles, children: [_jsxs(Box, { className: 'title-container', sx: titleContainerStyles, children: [goBack && (_jsx(IconButton, { size: 'large', onClick: handleGoBack, children: _jsx(ArrowLeftFilled, { fontSize: 28, color: theme.palette.action.active }) })), _jsxs(Box, { display: 'flex', alignItems: 'center', children: [breadcrumbs && (_jsxs(Typography, { color: 'textDisabled', variant: 'h4', children: [breadcrumbs, " /"] })), "\u00A0", _jsx(Typography, { variant: 'h4', children: truncateText(title, 50) })] }), icons && (_jsx(Box, { className: 'icon-container', sx: iconContainerStyles, children: icons }))] }), _jsx(Box, { className: 'filters-section', sx: filterSectionStyles, children: filters })] }));
};
export default PageHeader;
